import { render, staticRenderFns } from "./addThirdParty.vue?vue&type=template&id=384b85e2&scoped=true&"
import script from "./addThirdParty.vue?vue&type=script&lang=js&"
export * from "./addThirdParty.vue?vue&type=script&lang=js&"
import style0 from "./addThirdParty.vue?vue&type=style&index=0&id=384b85e2&lang=less&scoped=true&"
import style1 from "./addThirdParty.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384b85e2",
  null
  
)

export default component.exports